import {
    SELECT_STUDENT,
    SELECT_GRADE_YEAR,
    CLEAR_STUDENT_SUMMARY_DATA,
    FETCH_STUDENT_ENROLLMENT_INFO,
    FETCH_ALL_STUDENTS_ENROLLMENT_INFO,
} from '../../actionTypes/shared/apiActionTypes';
import parseGradeYearPair from './studentSummaryParsers';
import {
    getGradeYearByStudentId,
    getSortedAllStudentsGradeYears,
    getSortedGradeYears,
} from '../../../utils/shared/studentSummaryReducerHelper';

export const initialState = {
    selectedStudentId: null,
    gradeYears: [],
    allStudentsGradeYears: [],
    selectedGradeYear: {},
    error: null,
    isGradeYearsFetching: false,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SELECT_STUDENT:
            return {
                ...state,
                selectedStudentId: action.selectedStudentId,
            };
        case FETCH_STUDENT_ENROLLMENT_INFO.START:
        case FETCH_ALL_STUDENTS_ENROLLMENT_INFO.START:
            return {
                ...state,
                isGradeYearsFetching: true,
            };
        case FETCH_STUDENT_ENROLLMENT_INFO.SUCCESS:
            return {
                ...state,
                isGradeYearsFetching: false,
                gradeYears: getSortedGradeYears(
                    getGradeYearByStudentId(action.response, state.selectedStudentId),
                ),
            };
        case FETCH_ALL_STUDENTS_ENROLLMENT_INFO.SUCCESS:
            return {
                ...state,
                isGradeYearsFetching: false,
                allStudentsGradeYears: getSortedAllStudentsGradeYears(action.response),
            };
        case FETCH_STUDENT_ENROLLMENT_INFO.ERROR:
        case FETCH_ALL_STUDENTS_ENROLLMENT_INFO.ERROR:
            return {
                ...state,
                error: action.error,
                isGradeYearsFetching: false,
            };
        case CLEAR_STUDENT_SUMMARY_DATA:
            return initialState;
        case SELECT_GRADE_YEAR:
            return {
                ...state,
                selectedGradeYear: parseGradeYearPair(action.selectedGradeYear),
            };
        default:
            return state;
    }
};

const isGradeYearsFetching = state => state.isGradeYearsFetching;

const getGradeYears = state => state.gradeYears;

const getSelectedStudentId = state => state.selectedStudentId;

const getSelectedGradeYear = state => state.selectedGradeYear;

const getAllStudentsGradeYears = state => state.allStudentsGradeYears;

export const selectors = {
    getGradeYears,
    getSelectedStudentId,
    getSelectedGradeYear,
    isGradeYearsFetching,
    getAllStudentsGradeYears,
};
